export default "__VITE_ASSET__4KVZ9Ybp__"